__turbopack_context__.v({
  "align-center": "Typography-module__7D4soW__align-center",
  "align-end": "Typography-module__7D4soW__align-end",
  "align-start": "Typography-module__7D4soW__align-start",
  "eyebrow": "Typography-module__7D4soW__eyebrow",
  "heading": "Typography-module__7D4soW__heading",
  "size-2xl": "Typography-module__7D4soW__size-2xl",
  "size-base": "Typography-module__7D4soW__size-base",
  "size-hero": "Typography-module__7D4soW__size-hero",
  "size-lg": "Typography-module__7D4soW__size-lg",
  "size-md": "Typography-module__7D4soW__size-md",
  "size-sm": "Typography-module__7D4soW__size-sm",
  "size-xl": "Typography-module__7D4soW__size-xl",
  "size-xs": "Typography-module__7D4soW__size-xs",
  "text": "Typography-module__7D4soW__text",
  "tone-default": "Typography-module__7D4soW__tone-default",
  "tone-faint": "Typography-module__7D4soW__tone-faint",
  "tone-ghost": "Typography-module__7D4soW__tone-ghost",
  "tone-muted": "Typography-module__7D4soW__tone-muted",
  "tone-onLight": "Typography-module__7D4soW__tone-onLight",
  "tone-ruby": "Typography-module__7D4soW__tone-ruby",
  "uppercase": "Typography-module__7D4soW__uppercase",
  "w-bold": "Typography-module__7D4soW__w-bold",
  "w-light": "Typography-module__7D4soW__w-light",
  "w-medium": "Typography-module__7D4soW__w-medium",
  "w-regular": "Typography-module__7D4soW__w-regular",
  "w-thin": "Typography-module__7D4soW__w-thin",
});
